const SPEICHER_SCHLUESSEL = "ki-darstellung";
const VORGABE = { scheme: "SYSTEM", density: "COMPACT", schrift: "klein" };
const GUELTIGE_SCHEMATA = ["SYSTEM", "LIGHT", "DARK"];
const GUELTIGE_DICHTEN = ["COMPACT", "COMFORTABLE"];
const GUELTIGE_STUFEN = ["klein", "normal", "gross", "sehr-gross"];
function istColorScheme(wert) {
    return typeof wert === "string" && GUELTIGE_SCHEMATA.includes(wert);
}
function istDensity(wert) {
    return typeof wert === "string" && GUELTIGE_DICHTEN.includes(wert);
}
function istSchriftStufe(wert) {
    return typeof wert === "string" && GUELTIGE_STUFEN.includes(wert);
}
/**
 * Die Schriftstufe aus der Benutzereinstellung. AUTO ist die Gerätevorgabe (Dirk
 * 07.10.2026): "normal" am Telefon — schmal UND Finger, wegen der iOS-Zoomgrenze —,
 * sonst "klein" (Schreibtisch und iPad). Eine ausdrückliche Stufe gilt unabhängig vom Gerät.
 */
export function schriftAus(stufe, geraet) {
    if (stufe === "AUTO")
        return geraet.grob && geraet.breite <= 743 ? "normal" : "klein";
    return stufe === "SEHR_GROSS" ? "sehr-gross" : stufe.toLowerCase();
}
/** Fensterbreite und Zeigerart — die Eingaben von `schriftAus` für dieses Gerät. */
export function geraetErmitteln() {
    // Ohne matchMedia (alte WebViews, manche Testumgebungen) gilt das Gerät als fein,
    // also Vorgabe „klein“ — lieber eine Stufe zu klein als ein Absturz beim Start.
    const grob = typeof window.matchMedia === "function"
        ? window.matchMedia("(pointer: coarse)").matches : false;
    return { breite: window.innerWidth, grob };
}
/**
 * Setzt Farbschema, Dichte und Schriftstufe am <html>-Element und legt eine Kopie im
 * Browser ab, damit die Seite beim nächsten Aufruf sofort richtig aufbaut und nicht kurz
 * hell aufblitzt. Die verbindliche Quelle bleibt der Benutzersatz in der Datenbank.
 *
 * Das Farbschema steht doppelt: `data-theme` (hell|dunkel) schaltet die Tokendatei von
 * me-design, `data-ki-scheme` die Bestandsregeln, die noch darauf hören (Etappe 4 baut sie
 * ab). Bei SYSTEM fehlen beide — dann entscheidet prefers-color-scheme.
 */
export function applyTheme(scheme, density, schrift = "klein") {
    const wurzel = document.documentElement;
    if (scheme === "SYSTEM") {
        wurzel.removeAttribute("data-ki-scheme");
        wurzel.removeAttribute("data-theme");
    }
    else {
        wurzel.setAttribute("data-ki-scheme", scheme.toLowerCase());
        wurzel.setAttribute("data-theme", scheme === "DARK" ? "dunkel" : "hell");
    }
    wurzel.setAttribute("data-ki-density", density.toLowerCase());
    wurzel.setAttribute("data-schrift", schrift);
    const farbe = getComputedStyle(wurzel).getPropertyValue("--ki-surface").trim();
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", farbe);
    try {
        localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify({ scheme, density, schrift }));
    }
    catch {
        // Privater Modus oder blockierter Speicher — die Darstellung stimmt trotzdem.
    }
}
/**
 * Der zuletzt bekannte Stand, für den ersten Aufbau vor der Antwort des Servers — siehe
 * main.tsx, das dies vor dem ersten Zeichnen von React aufruft. Der Wert kommt aus
 * localStorage, also aus dem Browser: Er könnte fehlen, von einer älteren/neueren
 * Fassung stammen (ein Stand vor ME-Etappe 1 kennt keine Schriftstufe) oder von Hand
 * verändert worden sein. Jedes Feld wird deshalb einzeln geprüft und bei einem
 * unbrauchbaren Wert auf die Vorgabe zurückgesetzt, statt blind übernommen zu werden —
 * ein kaputtes Feld darf die anderen, gültigen Felder nicht mitreißen.
 */
export function readCachedTheme() {
    try {
        const roh = localStorage.getItem(SPEICHER_SCHLUESSEL);
        if (roh === null)
            return { ...VORGABE };
        const geparst = JSON.parse(roh);
        if (typeof geparst !== "object" || geparst === null)
            return { ...VORGABE };
        const kandidat = geparst;
        return {
            scheme: istColorScheme(kandidat.scheme) ? kandidat.scheme : VORGABE.scheme,
            density: istDensity(kandidat.density) ? kandidat.density : VORGABE.density,
            schrift: istSchriftStufe(kandidat.schrift) ? kandidat.schrift : VORGABE.schrift,
        };
    }
    catch {
        return { ...VORGABE };
    }
}
//# sourceMappingURL=applyTheme.js.map